import type { HTMLAttributes } from 'react'
import { cn } from '../../lib/utils'

/**
 * Constituent UI primitive: Skeleton
 *
 * Placeholder block for content that's loading. Pulses subtly but the pulse
 * is suppressed under prefers-reduced-motion.
 */
export function Skeleton({ className, ...rest }: HTMLAttributes<HTMLDivElement>) {
  return (
    <div
      aria-hidden="true"
      className={cn(
        'animate-pulse rounded-md bg-slate-200 motion-reduce:animate-none',
        className,
      )}
      {...rest}
    />
  )
}
